import dataModel from '../../models/DataModel.js';
import locationsService from '../../services/locationsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const location_root = {
  location: {
    market: {
      
    },
    location_users: {
      user: { },
    },
    users: {},
  },
};

export default class LocationsNavCollection extends AOCollection {
  constructor(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor) {
    super({
      name: ReduxConstants.LOCATIONS_NAV,
      collectionType: ReduxConstants.LOCATION,
      perPage, 
      searchString, 
      userId,
      companyId, 
      subKey,
      filter,
      recordDescriptor,
    });
  }

  static build(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor) {
    let collection = new LocationsNavCollection(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor);
    if (perPage) {
      collection.page = 0;
    }
    
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else this.page++;

        let serviceCall = locationsService.getLocations.bind(this, this._searchString, null, this.page, this.perPage, null, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        newCollection.totalLocations = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        let page = null;
        let perPage = null;
        
        // Get everything we already got
        if (shouldPaginate) {
          page = 1;
          if (collection && collection.perPage) {
            perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
    
        let serviceCall = locationsService.getLocations.bind(this, this._searchString, null, page, perPage, null, options);

        let newCollection = await this._fetchData(serviceCall, options);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
        
        newCollection.totalLocations = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/LocationsNavCollection.js